import { render, staticRenderFns } from "./RemoveButton.vue?vue&type=template&id=40dff3c2&scoped=true"
import script from "./RemoveButton.vue?vue&type=script&lang=js"
export * from "./RemoveButton.vue?vue&type=script&lang=js"
import style0 from "./RemoveButton.vue?vue&type=style&index=0&id=40dff3c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dff3c2",
  null
  
)

export default component.exports